import 'css-chunksrc/client/pages/projectPage/wbsPage/statuses/tasks/styles.scss';export default {
  "statuses": "_statuses_6jd6h_1",
  "tasks": "_tasks_6jd6h_8",
  "task": "_task_6jd6h_8",
  "loader": "_loader_6jd6h_22",
  "loaderMain": "_loaderMain_6jd6h_30",
  "dropPreview": "_dropPreview_6jd6h_37",
  "dropPreviewVisible": "_dropPreviewVisible_6jd6h_42",
  "dragged": "_dragged_6jd6h_47"
};